import { render, staticRenderFns } from "./AddKnownCard.vue?vue&type=template&id=ceb42b10&scoped=true"
import script from "./AddKnownCard.vue?vue&type=script&lang=js"
export * from "./AddKnownCard.vue?vue&type=script&lang=js"
import style0 from "./AddKnownCard.vue?vue&type=style&index=0&id=ceb42b10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb42b10",
  null
  
)

export default component.exports